const validate = (formData) => {
    const errors = {};
    if(formData.translations.length===0){
      errors.translations = true;
    }
    return errors;
}

export default validate;